import React from "react";
import { Dialog, DialogContent, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCheck, X } from "lucide-react"; // Import X for the close button

interface HireMeSuccessModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  designerName: string;
}

const HireMeSuccessModal: React.FC<HireMeSuccessModalProps> = ({
  isOpen,
  onOpenChange,
  designerName,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="h-full flex flex-col justify-center items-center max-w-none bg-white/20 backdrop-blur-md border-none shadow-none">
        {/* Custom centered close button at the top */}
        <div className="">
          <DialogClose className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-md hover:bg-gray-50 transition-colors">
            <X size={16} className="text-gray-500" />
            <span className="sr-only">Close</span>
          </DialogClose>
        </div>
        {/* Center card container with max width */}
        <div className="relative w-full max-w-[500px] bg-white rounded-xl overflow-hidden flex flex-col p-8 items-center justify-center text-center">
          <CheckCheck size={48} className="text-green-500 mb-4" />
          <h3 className="text-lg font-semibold mb-2">Thanks!</h3>
          <p className="text-sm text-gray-600 mb-6">
            Your request was sent to <span className="font-medium">{designerName}</span>.
            They'll reach out soon.
          </p>
          <DialogClose asChild>
            <Button className="w-full bg-black text-white hover:bg-gray-800">
              Close
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HireMeSuccessModal; 